module.exports = __webpack_public_path__ + "img/construction.dbead02b.svg";